import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { IconType } from 'react-icons';
import { AlertIcon, SuccessIcon, InfoIcon, ErrorIcon } from 'app/agriculture/icons';

const toastIcons: Record<AgricultureToastType, IconType> = {
    [AgricultureToastType.WARNING]: AlertIcon,
    [AgricultureToastType.ERROR]: ErrorIcon,
    [AgricultureToastType.INFO]: InfoIcon,
    [AgricultureToastType.SUCCESS]: SuccessIcon,
};

interface ToastIconProps {
    className?: string;
    type: AgricultureToastType;
}

export function ToastIcon({ type, className }: ToastIconProps) {
    const Icon = toastIcons[type];
    return <Icon className={className} />;
}
